var $6BmjZ$react = require("react");
var $6BmjZ$reactjsxruntime = require("react/jsx-runtime");
var $6BmjZ$classnames = require("classnames");
var $6BmjZ$styledcomponents = require("styled-components");
var $6BmjZ$muimaterialInputAdornment = require("@mui/material/InputAdornment");
var $6BmjZ$muimaterialTextField = require("@mui/material/TextField");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "InputWithIcon", {
    enumerable: true,
    get: function get() {
        return $9d956205d110a51c$exports.InputWithIcon;
    }
});
var $9d956205d110a51c$exports = {};
"use strict";
Object.defineProperty($9d956205d110a51c$exports, "__esModule", {
    value: true
});
$9d956205d110a51c$exports.InputWithIcon = void 0;

var $9d956205d110a51c$var$_react = $9d956205d110a51c$var$_interopRequireDefault($6BmjZ$react);
var $560e03a786e6e181$exports = {};
"use strict";
Object.defineProperty($560e03a786e6e181$exports, "__esModule", {
    value: true
});
$560e03a786e6e181$exports.TextField = $560e03a786e6e181$exports.LabelWrapper = $560e03a786e6e181$exports.InputAdornment = void 0;

var $560e03a786e6e181$var$_classnames = $560e03a786e6e181$var$_interopRequireDefault($6BmjZ$classnames);

var $560e03a786e6e181$var$_styledComponents = $560e03a786e6e181$var$_interopRequireDefault($6BmjZ$styledcomponents);

var $560e03a786e6e181$var$_InputAdornment = $560e03a786e6e181$var$_interopRequireDefault($6BmjZ$muimaterialInputAdornment);

var $560e03a786e6e181$var$_TextField = $560e03a786e6e181$var$_interopRequireDefault($6BmjZ$muimaterialTextField);
var $560e03a786e6e181$var$_templateObject, $560e03a786e6e181$var$_templateObject2, $560e03a786e6e181$var$_templateObject3;
function $560e03a786e6e181$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $560e03a786e6e181$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $560e03a786e6e181$var$TextField = $560e03a786e6e181$exports.TextField = (0, $560e03a786e6e181$var$_styledComponents["default"])($560e03a786e6e181$var$_TextField["default"])($560e03a786e6e181$var$_templateObject || ($560e03a786e6e181$var$_templateObject = $560e03a786e6e181$var$_taggedTemplateLiteral([
    "\n  width: 100%;\n  border-radius: 4px;\n\n  .InputLabel-root {\n    ",
    ";\n    color: ",
    ";\n    ",
    ";\n    margin-left: 15px;\n\n    &.Mui-disabled {\n      color: ",
    ";\n\n      path {\n        fill: ",
    ";\n      }\n    }\n\n    &.MuiInputLabel-filled {\n      transform: translate(10px, 14px) scale(1);\n    }\n\n    &.MuiInputLabel-filled.MuiInputLabel-shrink {\n      transform: translate(10px, 6px) scale(0.75);\n    }\n\n    .MuiFilledInput-adornedStart {\n      padding-left: 10px;\n    }\n  }\n\n  & label.Mui-focused {\n    color: ",
    ";\n\n    path {\n      fill: ",
    ";\n    }\n  }\n\n  .Input-root {\n    ",
    ";\n    background: ",
    ";\n    ",
    ";\n    border-radius: 4px;\n    margin-top: 0px;\n    height: 56px;\n    border: 0px;\n    padding-left: 25px;\n\n    &.Mui-disabled {\n      background-color: ",
    ";\n      color: ",
    ";\n    }\n\n    input {\n      padding: 27px 10px 10px 0px;\n\n      &::placeholder {\n        color: ",
    ";\n        opacity: 1;\n      }\n    }\n  }\n"
])), function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.color.g600;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.fontWeight.regular;
}, function(props) {
    return props.theme.color.g300;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.color.g500;
});
var $560e03a786e6e181$var$InputAdornment = $560e03a786e6e181$exports.InputAdornment = (0, $560e03a786e6e181$var$_styledComponents["default"])($560e03a786e6e181$var$_InputAdornment["default"]).attrs(function(props) {
    var _props$classes;
    return {
        classes: {
            root: (0, $560e03a786e6e181$var$_classnames["default"])("root", (_props$classes = props.classes) === null || _props$classes === void 0 ? void 0 : _props$classes.root)
        }
    };
})($560e03a786e6e181$var$_templateObject2 || ($560e03a786e6e181$var$_templateObject2 = $560e03a786e6e181$var$_taggedTemplateLiteral([
    "\n  &.root {\n    margin-right: 5px;\n  }\n"
])));
var $560e03a786e6e181$var$LabelWrapper = $560e03a786e6e181$exports.LabelWrapper = $560e03a786e6e181$var$_styledComponents["default"].div($560e03a786e6e181$var$_templateObject3 || ($560e03a786e6e181$var$_templateObject3 = $560e03a786e6e181$var$_taggedTemplateLiteral([
    "\n  position: relative;\n\n  svg {\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    left: -17px;\n    margin-top: 7px;\n  }\n"
])));



function $9d956205d110a51c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $9d956205d110a51c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9d956205d110a51c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9d956205d110a51c$var$_typeof(o);
}
function $9d956205d110a51c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d956205d110a51c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d956205d110a51c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9d956205d110a51c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d956205d110a51c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9d956205d110a51c$var$_defineProperty(e, r, t) {
    return (r = $9d956205d110a51c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9d956205d110a51c$var$_toPropertyKey(t) {
    var i = $9d956205d110a51c$var$_toPrimitive(t, "string");
    return "symbol" == $9d956205d110a51c$var$_typeof(i) ? i : i + "";
}
function $9d956205d110a51c$var$_toPrimitive(t, r) {
    if ("object" != $9d956205d110a51c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9d956205d110a51c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9d956205d110a51c$var$Label = function Label(props) {
    var label = props.label, icon = props.icon;
    return /*#__PURE__*/ (0, $6BmjZ$reactjsxruntime.jsxs)($560e03a786e6e181$exports.LabelWrapper, {
        children: [
            icon,
            /*#__PURE__*/ (0, $6BmjZ$reactjsxruntime.jsx)("span", {
                children: label
            })
        ]
    });
};
var $9d956205d110a51c$var$InputWithIcon = $9d956205d110a51c$exports.InputWithIcon = /*#__PURE__*/ $9d956205d110a51c$var$_react["default"].forwardRef(function(props, ref) {
    var label = props.label, prefix = props.prefix, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? "" : _props$autoComplete, autoFocus = props.autoFocus, classes = props.classes, InputLabelProps = props.InputLabelProps, _props$placeholder = props.placeholder, placeholder = _props$placeholder === void 0 ? "" : _props$placeholder, onChange = props.onChange, _props$value = props.value, value = _props$value === void 0 ? "" : _props$value, _props$name = props.name, name = _props$name === void 0 ? "" : _props$name, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? null : _props$onBlur, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? null : _props$onFocus, className = props.className, icon = props.icon, testId = props["data-testid"];
    var startAdornment = prefix && /*#__PURE__*/ (0, $6BmjZ$reactjsxruntime.jsx)($560e03a786e6e181$exports.InputAdornment, {
        position: "start",
        classes: {
            root: classes === null || classes === void 0 ? void 0 : classes.startAdornment,
            positionStart: "MuiInputLabel-startAdornment"
        },
        children: prefix
    });
    var events = {};
    if (onBlur) events.onBlur = onBlur;
    if (onFocus) events.onFocus = onFocus;
    return /*#__PURE__*/ (0, $6BmjZ$reactjsxruntime.jsx)($560e03a786e6e181$exports.TextField, $9d956205d110a51c$var$_objectSpread($9d956205d110a51c$var$_objectSpread({
        name: name,
        className: className,
        inputRef: ref,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        disabled: disabled,
        label: /*#__PURE__*/ (0, $6BmjZ$reactjsxruntime.jsx)($9d956205d110a51c$var$Label, {
            label: label,
            icon: icon
        }),
        placeholder: placeholder,
        onChange: onChange,
        value: value,
        variant: "filled",
        type: type
    }, events), {}, {
        InputLabelProps: $9d956205d110a51c$var$_objectSpread($9d956205d110a51c$var$_objectSpread({}, InputLabelProps), {}, {
            classes: $9d956205d110a51c$var$_objectSpread($9d956205d110a51c$var$_objectSpread({
                filled: "MuiInputLabel-filled",
                shrink: "MuiInputLabel-shrink"
            }, InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.classes), {}, {
                root: "InputLabel-root"
            }),
            shrink: true
        }),
        InputProps: {
            classes: {
                root: "Input-root Input-".concat(type, "-root"),
                input: classes === null || classes === void 0 ? void 0 : classes.input,
                focused: classes === null || classes === void 0 ? void 0 : classes.focused
            },
            startAdornment: startAdornment,
            disableUnderline: true
        },
        "data-testid": testId
    }));
});




//# sourceMappingURL=index.js.map
